/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlFilter = exports.ResolutionMethod = exports.ProvisionRequestInitiator = exports.PremiumFeature = exports.PendingReason = exports.Namespace = exports.Kind = exports.HttpsPolicy = exports.FormFace = exports.Flag = exports.DocumentType = exports.DeleteStatus = exports.Compatibility = exports.CollectionExposure = exports.ApplicationType = exports.AppState = exports.ApiState = void 0;
var ApiState;
(function (ApiState) {
    ApiState["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    ApiState["TEMPLATE"] = "TEMPLATE";
    ApiState["STUB"] = "STUB";
    ApiState["INITIALIZED"] = "INITIALIZED";
})(ApiState = exports.ApiState || (exports.ApiState = {}));
var AppState;
(function (AppState) {
    AppState["UNKNOWN"] = "UNKNOWN";
    AppState["ENABLED"] = "ENABLED";
    AppState["DISABLED"] = "DISABLED";
    AppState["TEMPLATE"] = "TEMPLATE";
    AppState["PENDING"] = "PENDING";
})(AppState = exports.AppState || (exports.AppState = {}));
var ApplicationType;
(function (ApplicationType) {
    ApplicationType["UNKNOWN_APPLICATION_TYPE"] = "UNKNOWN_APPLICATION_TYPE";
    ApplicationType["FLASH"] = "FLASH";
    ApplicationType["FLASH_FACEBOOK"] = "FLASH_FACEBOOK";
    ApplicationType["FLASH_WIDGET"] = "FLASH_WIDGET";
    ApplicationType["FLASH_BANNER"] = "FLASH_BANNER";
    ApplicationType["HTML_MOBILE"] = "HTML_MOBILE";
    ApplicationType["HTML_WEB"] = "HTML_WEB";
    ApplicationType["HTML_FACEBOOK"] = "HTML_FACEBOOK";
    ApplicationType["BLOG"] = "BLOG";
    ApplicationType["WIX_LISTS"] = "WIX_LISTS";
    ApplicationType["STATIC_MOUNT"] = "STATIC_MOUNT";
    ApplicationType["STATIC_MOUNT_REDIRECT"] = "STATIC_MOUNT_REDIRECT";
    ApplicationType["AMP_BLOG"] = "AMP_BLOG";
    ApplicationType["COMMUNITIES_AMP_BLOG"] = "COMMUNITIES_AMP_BLOG";
    ApplicationType["HTML_ANYWHERE"] = "HTML_ANYWHERE";
    ApplicationType["HOPP"] = "HOPP";
})(ApplicationType = exports.ApplicationType || (exports.ApplicationType = {}));
var CollectionExposure;
(function (CollectionExposure) {
    CollectionExposure["PUBLIC"] = "PUBLIC";
    CollectionExposure["WIX_INTERNAL"] = "WIX_INTERNAL";
})(CollectionExposure = exports.CollectionExposure || (exports.CollectionExposure = {}));
var Compatibility;
(function (Compatibility) {
    Compatibility["UNKNOWN_COMPATIBILITY"] = "UNKNOWN_COMPATIBILITY";
    Compatibility["WEB"] = "WEB";
    Compatibility["MOBILE"] = "MOBILE";
    Compatibility["ALL"] = "ALL";
})(Compatibility = exports.Compatibility || (exports.Compatibility = {}));
var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus = exports.DeleteStatus || (exports.DeleteStatus = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["UNKNOWN_DOCUMENT_TYPE"] = "UNKNOWN_DOCUMENT_TYPE";
    DocumentType["UGC"] = "UGC";
    DocumentType["TEMPLATE"] = "TEMPLATE";
    DocumentType["WIX_SITE"] = "WIX_SITE";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var Flag;
(function (Flag) {
    Flag["UNKNOWN_FLAG"] = "UNKNOWN_FLAG";
    Flag["URL_MIGRATED"] = "URL_MIGRATED";
    Flag["USE_HTTPS"] = "USE_HTTPS";
    Flag["EDITOR_X"] = "EDITOR_X";
    Flag["BLOCKED"] = "BLOCKED";
    Flag["DONT_USE_DEFAULT_ROUTING"] = "DONT_USE_DEFAULT_ROUTING";
    Flag["STUDIO"] = "STUDIO";
    Flag["CRITICAL_ASSET"] = "CRITICAL_ASSET";
})(Flag = exports.Flag || (exports.Flag = {}));
var FormFace;
(function (FormFace) {
    FormFace["REGISTER"] = "REGISTER";
    FormFace["LOGIN"] = "LOGIN";
})(FormFace = exports.FormFace || (exports.FormFace = {}));
var HttpsPolicy;
(function (HttpsPolicy) {
    HttpsPolicy["UNKNOWN_HTTPS_POLICY"] = "UNKNOWN_HTTPS_POLICY";
    HttpsPolicy["DISALLOW"] = "DISALLOW";
    HttpsPolicy["ALLOW"] = "ALLOW";
    HttpsPolicy["ENFORCE"] = "ENFORCE";
})(HttpsPolicy = exports.HttpsPolicy || (exports.HttpsPolicy = {}));
var Kind;
(function (Kind) {
    Kind["OPEN"] = "OPEN";
    Kind["CLOSED"] = "CLOSED";
    Kind["APPLY_FOR_MEMBERSHIP"] = "APPLY_FOR_MEMBERSHIP";
})(Kind = exports.Kind || (exports.Kind = {}));
var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    Namespace["WIX"] = "WIX";
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    Namespace["ALBUMS"] = "ALBUMS";
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    Namespace["HOTELS"] = "HOTELS";
    Namespace["CLUBS"] = "CLUBS";
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    Namespace["DEV_SITE"] = "DEV_SITE";
    Namespace["LOGOS"] = "LOGOS";
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    Namespace["ANYWHERE"] = "ANYWHERE";
    Namespace["HEADLESS"] = "HEADLESS";
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    Namespace["RISE"] = "RISE";
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
    Namespace["NOWNIA"] = "NOWNIA";
    Namespace["UGC_TEMPLATE"] = "UGC_TEMPLATE";
    Namespace["CODUX"] = "CODUX";
})(Namespace = exports.Namespace || (exports.Namespace = {}));
var PendingReason;
(function (PendingReason) {
    PendingReason["UNKNOWN"] = "UNKNOWN";
    PendingReason["PREMIUM"] = "PREMIUM";
    PendingReason["APP_MARKET"] = "APP_MARKET";
})(PendingReason = exports.PendingReason || (exports.PendingReason = {}));
var PremiumFeature;
(function (PremiumFeature) {
    PremiumFeature["UNKNOWN_PREMIUM_FEATURE"] = "UNKNOWN_PREMIUM_FEATURE";
    PremiumFeature["SHOW_WIX_WHILE_LOADING"] = "SHOW_WIX_WHILE_LOADING";
    PremiumFeature["ADS_FREE"] = "ADS_FREE";
    PremiumFeature["HAS_ECOMMERCE"] = "HAS_ECOMMERCE";
    PremiumFeature["HAS_DOMAIN"] = "HAS_DOMAIN";
    PremiumFeature["ALWAYS_SHOW_FOOTER"] = "ALWAYS_SHOW_FOOTER";
    PremiumFeature["NO_ADS_IN_SOCIAL_SITES"] = "NO_ADS_IN_SOCIAL_SITES";
})(PremiumFeature = exports.PremiumFeature || (exports.PremiumFeature = {}));
var ProvisionRequestInitiator;
(function (ProvisionRequestInitiator) {
    ProvisionRequestInitiator["UNKNOWN"] = "UNKNOWN";
    ProvisionRequestInitiator["DASHBOARD"] = "DASHBOARD";
    ProvisionRequestInitiator["ONE_APP"] = "ONE_APP";
})(ProvisionRequestInitiator = exports.ProvisionRequestInitiator || (exports.ProvisionRequestInitiator = {}));
var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod = exports.ResolutionMethod || (exports.ResolutionMethod = {}));
var UrlFilter;
(function (UrlFilter) {
    UrlFilter["NO_URL_TYPE_FILTER"] = "NO_URL_TYPE_FILTER";
    UrlFilter["FREE"] = "FREE";
})(UrlFilter = exports.UrlFilter || (exports.UrlFilter = {}));
//# sourceMappingURL=types.js.map